export default "__VITE_ASSET__BUx0AtU7__"